import React, { FC, Fragment, ReactNode } from 'react';
import { Box, Unstable_Grid2 as Grid } from '@mui/material';
import { chunk } from 'lodash';

import { GetFeedQueryVariables, GroupFragment } from 'api';
import { useGetFeed } from 'hooks';
import { Loaders } from 'components';
import { SmallSection } from 'features/feed';

interface Props {
  emptyState: ReactNode;
  group: GroupFragment;
  feedHeader: ReactNode;
  header: ReactNode;
  variables: GetFeedQueryVariables;
}

const LOADER_HEIGHT = 32;

const GroupPostsGrid: FC<Props> = ({ emptyState, feedHeader, header, variables }) => {
  const { results, sentinelRef, isEmpty, isExhausted, isInitialLoad } = useGetFeed(variables);

  function renderLoadMoreLoader() {
    if (isEmpty || isInitialLoad || isExhausted) {
      return <div style={{ height: LOADER_HEIGHT }} />;
    }

    return <Loaders.Standard height={LOADER_HEIGHT} />;
  }

  function renderPosts() {
    const chunkedResults = chunk(results, 3);

    if (isInitialLoad) {
      return <Loaders.Feed />;
    }

    if (isEmpty) {
      return emptyState;
    }

    return chunkedResults.map((chunk, index) => (
      <Fragment key={index}>
        <Box marginTop={index === 0 ? 0 : 5}>
          <SmallSection key={index} results={[chunk[0], chunk[1], chunk[2]]} />
        </Box>
      </Fragment>
    ));
  }

  return (
    <Fragment>
      <Grid container>
        <Grid xs={12} marginBottom={2}>
          {header}
        </Grid>
        <Grid xs={12}>{feedHeader}</Grid>
      </Grid>
      {renderPosts()}
      <Box ref={sentinelRef} marginTop={5}>
        {renderLoadMoreLoader()}
      </Box>
    </Fragment>
  );
};

export default GroupPostsGrid;
